import React from 'react';
import AppLayout from '../../layout/app.layout';
import PAGE_TITLE_LIST from '../../config/page-title.config';
import ListWatchSessions from '../../components/reports/list-watch-sessions.component';

const ReportsWatchSessionsView = () => {
  const pageTitle = PAGE_TITLE_LIST.REPORTS_WATCH_SESSIONS;

  return (
    <AppLayout pageTitle={pageTitle}>
      <ListWatchSessions />
    </AppLayout>
  );
};

export default ReportsWatchSessionsView;
